import React, { useEffect, useState } from 'react';
import { 
  FaHandshake, 
  FaUsers, 
  FaLightbulb, 
  FaShieldAlt,
  FaRocket,
  FaHeadset
} from 'react-icons/fa';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const element = document.querySelector('.features-container');
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);

  const features = [
    {
      icon: <FaHandshake />,
      title: 'Strategic Partnerships',
      description:
        'We build long-term strategic partnerships with our clients, sharing resources and expertise to achieve common goals and create mutual value in the digital marketplace.'
    },
    {
      icon: <FaUsers />,
      title: 'Experienced Team',
      description:
        'Our team consists of skilled professionals with extensive experience in digital technologies, ensuring open communication and collaborative success for every project.'
    },
    {
      icon: <FaLightbulb />,
      title: 'Innovative Solutions',
      description:
        'We embrace creativity and innovation to deliver cutting-edge solutions that give you a competitive advantage and drive sustainable business growth.'
    },
    {
      icon: <FaShieldAlt />,
      title: 'Quality Assurance',
      description:
        'We maintain the highest standards of quality in every project, with rigorous testing and quality control measures to ensure reliable and secure solutions.'
    },
    {
      icon: <FaRocket />,
      title: 'Fast Delivery',
      description:
        'Our efficient development process and project management ensure timely delivery without compromising on quality, keeping your business ahead of the competition.'
    },
    {
      icon: <FaHeadset />,
      title: '24/7 Support',
      description:
        'We provide comprehensive post-delivery support and maintenance services to ensure your digital solutions continue to perform optimally and evolve with your business needs.'
    }
  ];

  return (
    <section className="why-choose-section section">
      <div className="container">
        <div className="section-title">
          <span className="section-subtitle">Why Choose Us</span>
          <h2>What Sets Our Digital Solutions Apart</h2>
          <p>
            We combine technical expertise with strategic thinking to deliver
            digital solutions that not only meet your current needs but also
            scale with your business growth.
          </p>
        </div>

        <div className={`features-container ${isVisible ? 'visible' : ''}`}>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div
                key={index}
                className="feature-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="feature-icon-container">
                  <div className="feature-icon">{feature.icon}</div>
                  <div className="icon-bg"></div>
                </div>

                <div className="feature-content">
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>

                <div className="feature-hover-effect"></div>
              </div>
            ))}
          </div>
        </div>

        <div className="why-choose-stats">
          <div className="stats-row">
            <div className="stat-item">
              <span className="stat-number">100%</span>
              <span className="stat-label">Client Satisfaction</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">24/7</span>
              <span className="stat-label">Support Available</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">99.9%</span>
              <span className="stat-label">Uptime Guarantee</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">48hrs</span>
              <span className="stat-label">Response Time</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
